import { InfoIcon, MinusCircle, X } from 'lucide-react';
import { Button, cn } from '@sandtech-hub-monorepo/ui-kit';
import { AcademicStanding } from '@sandtech-hub-monorepo/ehub-client';
import { ReactComponent as FileXIcon } from '../../../assets/Icons/file-x.svg';
import { getSeverityLabel } from '../academic-standing-labels';

interface Props {
  academicStanding: AcademicStanding;
  reason: string;
  onReadMore: () => void;
}

export const AcademicStandingBanner = ({
  academicStanding,
  reason,
  onReadMore,
}: Props) => {
  if (academicStanding === AcademicStanding.GoodAcademicStanding) {
    return null;
  }

  const isWarning = academicStanding === AcademicStanding.ScholasticWarning;
  const isProbation = academicStanding === AcademicStanding.AcademicProbation;
  const isSuspension = academicStanding === AcademicStanding.AcademicSuspension;
  const isDismissal = academicStanding === AcademicStanding.AcademicDismissal;

  const statusLabel = getSeverityLabel(academicStanding);

  const linkLabel = isWarning ? 'View More' : 'Read more';

  return (
    <div
      className={cn(
        'px-4 py-2 flex flex-col sm:flex-row gap-2 lg:gap-4 items-center border w-full rounded-lg',
        isWarning
          ? 'border-warning bg-warning/10 text-warning'
          : 'border-destructive bg-destructive/10 text-destructive'
      )}
    >
      {isWarning && <InfoIcon className="shrink-0 h-6 w-6" />}
      {isProbation && <FileXIcon className="shrink-0 h-6 w-6" />}
      {isSuspension && <MinusCircle className="shrink-0 h-6 w-6" />}
      {isDismissal && <X className="shrink-0 h-6 w-6" />}
      <span className="flex-1 text-sm">
        <span className="font-semibold">{statusLabel}:</span> {reason}
      </span>
      <Button
        variant="link"
        className={cn(
          'h-fit p-0 text-sm font-semibold underline shrink-0 sm:ml-auto',
          isWarning ? 'text-warning' : 'text-destructive'
        )}
        onClick={onReadMore}
      >
        {linkLabel}
      </Button>
    </div>
  );
};
